import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const NavCircle = ({ isActive = false, isRed = false }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <motion.div
      className={`fixed pointer-events-none z-50 ${
        isRed ? 'bg-[#D3242A]' : 'bg-white'
      }`}
      style={{
        x: mousePosition.x - 8,
        y: mousePosition.y - 8,
      }}
      animate={{
        scale: isActive ? 1.2 : isHovering ? 1.1 : 1,
        opacity: isActive ? 1 : isHovering ? 0.8 : 0.6,
      }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 20
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className="w-4 h-4 rounded-full" />
    </motion.div>
  );
};

export default NavCircle; 